import React from 'react';

import './NotificationDot.scoped.scss';
import classnames from 'classnames';

interface Props {
  children?: React.ReactNode;
}

const NotificationDot: React.FC<Props> = ({ children }) => {
  const numberOfNotifications = children;
  const onDigit = numberOfNotifications < 10;

  return (
    <div className="notification-dot">
      <p className={classnames({ onDigit })}>{children}</p>
    </div>
  );
};

export default NotificationDot;
